import Swiper from 'swiper';

export default function init() {
    const thumbsNext = document.querySelector('.gallery-thumbnails-next');
    const thumbsPrev = document.querySelector('.gallery-thumbnails-prev');
    const thumbnails = document.querySelectorAll(
        '#gallery-thumbnails .swiper-slide'
    );
    const sliderDetail = document.querySelectorAll('#gallery-main .slider-list-item');
    let thumbsSwiper, gallerySwiper;
    if (thumbnails.length > 3) {
        thumbsSwiper = new Swiper('#gallery-thumbnails', {
            direction: 'vertical',
            simulateTouch: false,
            slidesPerView: 3,
            spaceBetween: 15,
            onSlideChangeStart: () => {
                if (thumbsSwiper.isBeginning) {
                    thumbsPrev.classList.add('disable');
                } else {
                    thumbsPrev.classList.remove('disable');
                }
                if (thumbsSwiper.isEnd) {
                    thumbsNext.classList.add('disable');
                } else {
                    thumbsNext.classList.remove('disable');
                }
            },
            onReachBeginning: () => thumbsPrev.classList.add('disable'),
            onReachEnd: () => thumbsNext.classList.add('disable')
        });
    }
    if (thumbnails.length) {
        gallerySwiper = new Swiper('#gallery-main', {
            effect: window.innerWidth < 1024 ? 'slide' : 'fade',
            pagination: '.gallery-pagination',
            paginationClickable: true,
            onTransitionStart: () => {
                thumbnails.forEach((thumbnail, index) => {
                    if (index === gallerySwiper.activeIndex) {
                        thumbnail.classList.add('active');
                    } else {
                        thumbnail.classList.remove('active');
                    }
                });
                if (gallerySwiper.activeIndex % 3 === 0 &&
                    typeof thumbsSwiper === 'object') {
                    thumbsSwiper.slideTo(gallerySwiper.activeIndex);
                }
            }
        });
    }
    if (thumbsNext && thumbsPrev) {
        thumbsNext.addEventListener('click', () =>
            thumbsSwiper.slideTo(thumbsSwiper.activeIndex + 3)
        );
        thumbsPrev.addEventListener('click', () =>
            thumbsSwiper.slideTo(thumbsSwiper.activeIndex - 3)
        );
    }
    thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
            thumbnails.forEach((thumb) => {
                if (thumbnail === thumb) {
                    thumb.setAttribute('aria-current', 'true');
                    thumb.classList.add('active');
                } else {
                    thumb.removeAttribute('aria-current');
                    thumb.classList.remove('active');
                }
            });
            if (typeof gallerySwiper === 'object') {
                gallerySwiper.slideTo(index);
            }
        });
    });

    sliderDetail.forEach((sliderDetailItem) => {
        if (sliderDetail.length === 1) {
            sliderDetailItem.classList.add('add-opacity');
        } else {
            sliderDetailItem.classList.remove('add-opacity');
        }
    });
}

$(document).ready(function() {
    $(document).on('click', '.promoCopySimo', function() {
        let copyText = $(this).attr('data-attr-copy');
        let clipBoardElem = document.createElement('textarea');
        document.body.appendChild(clipBoardElem);
        clipBoardElem.value = copyText;
        clipBoardElem.select();
        navigator.clipboard.writeText(clipBoardElem.value);
        document.execCommand('copy');
        document.body.removeChild(clipBoardElem);
    });
    $(document).on('hide.bs.modal', '.promoModal', function() {
        const focusedElement = document.activeElement;
        // Check if the focused element is inside this modal
        if (this.contains(focusedElement)) {
            focusedElement.blur();
        }
    });
    $(document).on('click', '.promoCopy, .promoCopySimo', function() {
        const copyText = $(this).attr('data-attr-copy');
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(copyText).catch(() => {
                fallbackCopy(copyText);
            });
        } else {
            fallbackCopy(copyText);
        }
        // Prevent Safari accessibility warning
        this.blur();
    });
    function fallbackCopy(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'absolute';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
    }
});
